let mutations = {
    setTeams(state, payload) {
        state.all = payload;
    },
    setCachedTeams(state, payload) {
        state.cachedAll = payload;
    },
    setStatuses(state, payload) {
        state.statuses = payload;
    },
    setTasks(state, payload) {
        state.tasks = payload;
    },
    setAbsenceTypes(state, payload) {
        state.absenceTypes = payload;
    },
    setSlotTitleSettings(state, payload) {
        state.slotTitleSettings = payload;
    },
    getGroups(state, payload) {
        // @TODO: uncomment to pagination purposes
        // state.groups = {
        //     ...state.groups,
        //     ...payload
        // };

        state.groups = payload;
    },
    setGhostGroup(state, payload) {
        state.ghostGroup = payload;
    },
    setFullDayAbsences(state, payload) {
        state.fullDayAbsences = payload;
    },
    setPartDayAbsences(state, payload) {
        state.partDayAbsences = payload;
    },
    setWeekSchedules(state, payload) {
        state.weekSchedules = payload;
    },
    updated(state, payload) {
        state.updated = payload;
    },
    draggingGroup(state, payload) {
        state.draggingGroup = payload;
    },
    person(state, payload) {
        state.person = payload;
    },
    canBeManaged(state, payload) {
        state.canBeManaged = payload;
    },
    proplanning(state, payload) {
        state.planning = payload;
    }
};

export default mutations;